import repository from "../Repository";

export default {
  /**
   * 参照API
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
  async list(screenId, payload) {
    return await repository.post(`lalert_eva_info`, payload, {
      headers: {
        s: screenId
      }
    });
  },

  /**
   * 再送信API
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
  async resend(screenId, payload) {
    return await repository.patch(`lalert_eva_info/resend`, payload, {
      headers: {
        s: screenId
      }
    });
  },

  /**
   * 削除API
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
  async delete(screenId, payload) {
    return await repository.patch(`lalert_eva_info/delete`, payload, {
      headers: {
        s: screenId
      }
    });
  }
};
